import { toApiNormal } from 'api/makeQuery'

export const cleanSort = (s?: { id: string; desc: boolean }) => {
  if (!s) return {}
  return toApiNormal({ [s.id]: s.desc ? -1 : 1 })
}

export const cleanFilters = <T extends Record<string, string | null>>(f?: T) => {
  if (!f) return

  const final = { ...f }
  for (const [k, v] of Object.entries(f)) {
    if (!v) delete final[k]
  }
  return final
}
